import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    description: 'line-clamp-2 text-sm <md:hidden',
    title: 'line-clamp-2 text-sm fw-bold'
  },
} satisfies VfConfig['articleCard']
